import { useState } from 'react';

import { Snackbar } from '@mui/material';

import Alert from 'domains/core/components/Alert';

type Props = {
    'data-testid'?: string;
    successMessage: string;
};

const SuccessSnackbar = ({ 'data-testid': dataTestId, successMessage }: Props) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            data-testid={dataTestId}
        >
            <Alert onClose={handleClose} severity="success">
                {successMessage}
            </Alert>
        </Snackbar>
    );
};

export default SuccessSnackbar;
